import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1 } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import joint from '../../../assets/v2/Partner/joint.svg';
import Chipsets from '../../../assets/v2/Partner/chipset-mediatek.svg';
import ODMs from '../../../assets/v2/Partner/ManuODMs.svg';
import MediaTek from '../../../assets/v2/Partner/mediatek.svg';
import innocom from '../../../assets/v2/Partner/innocom.svg';

const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  // background-color: #03103b;
  padding-bottom: 72px !important;
  padding-top: 96px !important;
  @media (max-width: 520px) {
    padding-bottom: 96px !important;
  }
`;
const SectionTitle = styled.div`
  // padding: 2rem 0;
  margin: 0 1rem;
  color: #1f2131;
  @media (max-width: 520px) {
    // text-align: center;
    width: 80%;
    // padding: 1rem 0;
    padding-bottom: 0;
  }

  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  // line-height: normal;
  letter-spacing: normal;
  text-align: left;
`;

const Rectangle = styled.div`
  width: 70%;
  padding: 2rem;
  // text-align:center;
  // max-height: 100px;
  background-color: #298de5;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  border-radius: 5rem;
  text-align: center;
  color: #fff;
  background-color: #765ebf;
`;
const MiddleText = styled.span`
  padding: 0 0 1rem;
  color: #4f5263;
  font-size: 18px;
  margin-bottom: 2.5rem;
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  //   padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;
const StyledImg = styled(LazyLoadImage)`
  height: 72px;
  @media (max-width: 520px) {
    height: 46px;
    margin: 10px;
  }
`;
const StyledImgBox = styled(LazyLoadImage)`
  width: 141px;
  height: 60px;
  border-radius: 4px;
  // box-shadow: 0 2px 6px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
  margin-top: 1rem;
`;
const SubSection = styled.div`
  display: grid;
  // align-items: start;
  justify-items: center;
  margin-bottom: 0;
  @media (max-width: 768px) {
    max-width: 450px;
  }
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(2, 50%);
  }
`;
const SubItemRight = styled.div`
  // min-height: 200px;
  max-width: 480px;
  width: 100%;
  display: grid;
  justify-items: center;
  @media (max-width: 520px) {
    margin: 0.5rem;
    min-height: 200px;
    padding-left: 1rem;
  }
  @media (min-width: 768px) {
    padding-left: 1rem;
    min-height: 170px;
    padding-right: 1rem;
  }
`;
const SubItemLeft = styled.div`
  // min-height: 200px;
  max-width: 480px;
  width: 100%;
  display: grid;
  justify-items: center;
  @media (max-width: 520px) {
    margin: 0.5rem;
    min-height: 200px;
    padding-left: 1rem;
  }
  @media (min-width: 768px) {
    padding-right: 1rem;
    min-height: 170px;
    padding-left: 1rem;
  }
`;

export default () => (
  <>
    <Section>
      <SubSection>
        <SubItemLeft>
          <div style={{ display: 'grid', justifyItems: 'center' }}>
            <SectionTitle>
              <div style={{ display: 'grid', gridTemplateColumns: '3fr 10fr' }}>
                <div style={{ paddingRight: '0.5rem' }}>
                  <ImgWrapper>
                    <StyledImg src={Chipsets} />
                  </ImgWrapper>
                </div>
                <div
                  style={{
                    color: '#4f5263',
                    fontSize: '16px',
                    fontWeight: 'normal',
                  }}
                >
                  <p
                    style={{
                      color: '#151828',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    }}
                  >
                    Chipsets
                  </p>
                  Design and contract manufacturers.
                </div>
              </div>
            </SectionTitle>
            <div>
              <StyledImgBox src={MediaTek} />
            </div>
          </div>
        </SubItemLeft>
        <SubItemRight>
          <div style={{ display: 'grid', justifyItems: 'center' }}>
            <SectionTitle>
              <div style={{ display: 'grid', gridTemplateColumns: '3fr 10fr' }}>
                <div style={{ paddingRight: '0.5rem' }}>
                  <ImgWrapper>
                    <StyledImg src={ODMs} />
                  </ImgWrapper>
                </div>
                <div
                  style={{
                    color: '#4f5263',
                    fontSize: '16px',
                    fontWeight: 'normal',
                  }}
                >
                  <p
                    style={{
                      color: '#151828',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    }}
                  >
                    Android Manufacturing | ODMs
                  </p>
                  Building kiosks, PoS, digital signage, & other hardware.
                </div>
              </div>
            </SectionTitle>
            <div>
              <StyledImgBox src={innocom} />
            </div>
          </div>
        </SubItemRight>
      </SubSection>
    </Section>
  </>
);
